import { render, staticRenderFns } from "./UserAdministration.vue?vue&type=template&id=78e76a56&"
import script from "./UserAdministration.vue?vue&type=script&lang=ts&"
export * from "./UserAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdministration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports